// extracted by mini-css-extract-plugin
export default {"container":"PackageVersions_container__Yz5FB","versionTable":"PackageVersions_versionTable__rodq2"};